let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("75XmY")).then(() => parcelRequire('iG3jk'));